import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=b3947cd8&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=b3947cd8&prod&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=b3947cd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3947cd8",
  null
  
)

export default component.exports